import * as React from "react";
import { SVGProps } from "react";

const ExportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5394 19.738H9.46056C5.63583 19.738 4 18.1256 4 14.3556V14.2558C4 10.8468 5.36319 9.20364 8.41675 8.91956C8.72833 8.89652 9.02434 9.12686 9.0555 9.44166C9.08666 9.75647 8.85297 10.0406 8.5258 10.0713C6.07984 10.2939 5.16845 11.4303 5.16845 14.2635V14.3633C5.16845 17.4883 6.29017 18.5939 9.46056 18.5939H14.5394C17.7098 18.5939 18.8315 17.4883 18.8315 14.3633V14.2635C18.8315 11.4149 17.9046 10.2786 15.4119 10.0713C15.0925 10.0406 14.851 9.76414 14.8822 9.44934C14.9133 9.13454 15.186 8.89652 15.5131 8.92723C18.6134 9.18829 20 10.8391 20 14.2712V14.371C20 18.1256 18.3642 19.738 14.5394 19.738Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M12.0002 14.7478C11.6809 14.7478 11.416 14.4867 11.416 14.1719V5.43425C11.416 5.11945 11.6809 4.8584 12.0002 4.8584C12.3196 4.8584 12.5845 5.11945 12.5845 5.43425V14.1719C12.5845 14.4867 12.3196 14.7478 12.0002 14.7478Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M14.61 7.72195C14.462 7.72195 14.3139 7.6682 14.1971 7.55303L12.0004 5.38781L9.80373 7.55303C9.57782 7.77569 9.20392 7.77569 8.97802 7.55303C8.75212 7.33036 8.75212 6.96182 8.97802 6.73915L11.5876 4.167C11.8135 3.94433 12.1874 3.94433 12.4133 4.167L15.0228 6.73915C15.2487 6.96182 15.2487 7.33036 15.0228 7.55303C14.9138 7.6682 14.758 7.72195 14.61 7.72195Z"
      fill={props.fill || "#1A1C1F"}
    />
  </svg>
);
export default ExportIcon;
